import React from 'react';
import { Link } from 'react-router-dom';

class Forbidden extends React.Component {
  state = {
    message: window.errorMessage,
    seconds: 9,
  }

  componentDidMount() {
    const { redirectUrl } = this.props;
    window.setErrorMessage = (message) => {
      this.setState({
        message,
      });
    };
    this.interval = setInterval(() => {
      if (this.state.seconds > 0) {
        this.setState({ seconds: this.state.seconds - 1 });
      } else {
        this.props.history.push(redirectUrl);
      }
    }, 1000);
  }

  componentWillUnmount() {
    this.interval && clearInterval(this.interval);
  }

  render() {
    const { message, seconds } = this.state;
    const { redirectUrl } = this.props;
    return (
      <div className={'Forbidden'}>
        <h1>您无权限查看此页面，详情请咨询管理员。</h1>
        <p>
          倒计时 {seconds} 秒后自动返回 <Link to={redirectUrl}>首页</Link>
        </p>
        <hr />
        {message && (
          <React.Fragment>
            <p>{message}</p>
            <hr />
          </React.Fragment>
        )}
        <p>如登录帐号不正确，请清除浏览器 Cookie 记录后重新登录；</p>
        <p>如登录帐号正确，请联系管理员。</p>
      </div>
    );
  }
}

export default Forbidden;
